import React from 'react';
import classnames from 'classnames';
import { useTheme } from '../theme';

export type CardHeaderProps = React.HTMLAttributes<HTMLDivElement>;

export const CardHeader = ({ className, ...props }: CardHeaderProps): React.ReactElement => {
  const theme = useTheme();
  const classNames = classnames(className, 'airtame-card__header');
  return <div className={classNames} data-theme={theme} {...props} />;
};

CardHeader.displayName = 'CardHeader';
